export default __webpack_public_path__ + "98fe9c19404e72c1d35300cf868c5ba4.png";